export default __webpack_public_path__ + "static/media/feature-bg.5f944b81.png";